<template>
  <div id="u-sidebar">
    <el-menu
      class="aside-menu"
      :style="{ width: isCollapse ? 'auto' : '216px' }"
      background-color="#26282b"
      router
      collapse-transition
      :collapse="isCollapse"
      :default-active="$route.path"
    >
      <template v-for="route in limitedRoutes">
        <template v-if="!route.meta.hideMenu">
          <!-- 一级 -->
          <el-submenu
            v-if="route.children && route.children.length"
            :popper-class="popperClass"
            :key="route.path"
            :index="route.path"
          >
            <template slot="title">
              <i :class="route.meta.icon" v-if="route.meta.icon"></i>
              <el-badge class="first-level" :is-dot="isParentShowBadge(route)">
                <span>{{ route.meta.title }}</span>
              </el-badge>
            </template>

            <!-- 二级 -->
            <template v-for="subRoute in route.children">
              <el-submenu
                v-if="subRoute.children && subRoute.children.length"
                :popper-class="popperClass"
                :key="subRoute.path"
                :index="subRoute.path"
                popper-append-to-body
              >
                <template slot="title">
                  <el-badge :is-dot="isParentShowBadge(subRoute)">
                    <span>{{ subRoute.meta.title }}</span>
                  </el-badge>
                </template>

                <!-- 三级 -->
                <el-menu-item
                  v-for="lastRoute in subRoute.children"
                  :key="`${route.path}/${subRoute.path}/${lastRoute.path}`"
                  :index="`${route.path}/${subRoute.path}/${lastRoute.path}`"
                >
                  <el-badge :is-dot="isShowBadge(lastRoute.path)">
                    <span>{{ lastRoute.meta.title }}</span>
                  </el-badge>
                </el-menu-item>
              </el-submenu>
              <!-- 普通菜单 -->
              <el-menu-item
                v-else
                :key="`${route.path}/${subRoute.path}`"
                :index="`${route.path}/${subRoute.path}`"
                @click="handelMenuClick(subRoute)"
              >
                <i :class="subRoute.meta.icon" v-if="subRoute.meta.icon"></i>
                <el-badge :is-dot="isShowBadge(subRoute.path)">
                  <span>{{ subRoute.meta.title }}</span>
                </el-badge>
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :key="route.path" :index="route.path">
            <i :class="route.meta.icon" v-if="route.meta.icon"></i>
            <el-badge :is-dot="isShowBadge(route.path)">
              <span>{{ route.meta.title }}</span>
            </el-badge>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <el-tooltip class="sidebar-collapse" :content="collapseText" placement="right" :open-delay="50">
      <span @click="isCollapse = !isCollapse"></span>
    </el-tooltip>
  </div>
</template>

<script>
import { routes } from '@/router'
import { userAgent, isMobilePortrait, lodash } from '@bike/fe-utils'
import badge from '@/mixins/badge.js'

export default {
  name: 'AsideMenu',
  mixins: [badge],
  data() {
    return {
      isCollapse: false,
      collapseText: '收起',
      limitedRoutes: [],
      popperClass: '',
    }
  },
  computed: {
    // 从UAC获取到的路由信息
    uacRouteNameList() {
      return this.$store.state.uacRouteNameList
    },
  },
  mounted() {
    this.genMenus()

    // 移动端默认收起菜单
    if (userAgent.isMobile()) {
      this.updatePopperClass()
      this.isCollapse = true
      this.collapseText = '展开'

      const _this = this
      const throttledUpdate = lodash.throttle(() => {
        // isMobilePortrait判断的是视口状态的变化，兼容延迟更新视口尺寸的浏览器
        setTimeout(() => {
          _this.updatePopperClass()
        }, 100)
      }, 200)

      // 监听屏幕方向的改变，更新popperClass，解决移动端横竖屏切换时二/三级菜单过多展示不全&无法滚动的问题
      if (screen && screen.orientation) {
        screen.orientation.addEventListener('change', throttledUpdate)
        this.$once('hook:beforeDestroy', function() {
          screen.orientation.removeEventListener('change', throttledUpdate)
        })
      } else {
        window.addEventListener('orientationchange', throttledUpdate)
        this.$once('hook:beforeDestroy', function() {
          window.removeEventListener('orientationchange', throttledUpdate)
        })
      }
    }
  },

  methods: {
    filterHideMenu(routes) {
      const helper = arr => {
        // 从后向前遍历，避免删除元素时影响索引
        for (let i = arr.length - 1; i >= 0; i--) {
          const item = arr[i]
          if (item.meta && item.meta.hideMenu) {
            arr.splice(i, 1)
            continue
          }
          if (item.children && item.children.length) {
            helper(item.children)
          }
        }
      }
      helper(routes)
    },
    genMenus() {
      // 根据从UAC获取到的路由信息过滤出需要显示的菜单
      // 最深3级，暂未使用递归实现
      this.filterHideMenu(routes)
      const accessedRoutes = []
      routes.forEach(l1 => {
        if (l1.children) {
          const accessdL1 = {
            ...l1,
            children: [],
          }
          l1.children.forEach(l2 => {
            const accessdL2 = {
              ...l2,
              children: [],
            }
            if (l2.children) {
              accessdL2.children = l2.children.filter(l3 => this.uacRouteNameList.includes(l3.name))
              if (accessdL2.children.length) accessdL1.children.push(accessdL2)
            } else if (this.uacRouteNameList.includes(l2.name)) {
              accessdL1.children.push(l2)
            }
          })
          if (accessdL1.children.length) accessedRoutes.push(accessdL1)
        } else if (this.uacRouteNameList.includes(l1.name)) {
          accessedRoutes.push(l1)
        }
      })
      this.limitedRoutes = accessedRoutes
    },

    // link直跳三方链接
    handelMenuClick(route) {
      const { menuURL, newOpen } = route
      if (!menuURL) return
      window.open(menuURL, newOpen ? '_blank' : '_self')
    },

    updatePopperClass() {
      const popperClass = isMobilePortrait() ? 'mb-submenu-portrait' : 'mb-submenu-landscape'
      this.$set(this, 'popperClass', popperClass)
    },
  },
  watch: {
    uacRouteNameList() {
      this.genMenus()
    },
    isCollapse(val) {
      window.postMessage({
        source: 'associateMenuCollapse',
        value: val,
      })
      setTimeout(() => {
        this.collapseText = val ? '展开' : '收起'
      }, 200)
    },
  },
}
</script>

<style lang="scss">
/* 竖屏模式 */
.mb-submenu-portrait {
  .el-menu {
    max-height: 500px;
    overflow-y: auto;
  }
}
/* 横屏模式 */
.mb-submenu-landscape {
  .el-menu {
    max-height: 300px;
    overflow-y: auto;
  }
}
#u-sidebar {
  position: relative;
  height: 100%;
  .el-menu.aside-menu {
    max-height: 100vh;
    overflow-y: auto;
    .iconfont {
      margin-right: 8px;
    }
    .el-badge {
      .el-badge__content {
        border: none;
        &.is-dot {
          width: 6px;
          height: 6px;
        }
        &.is-fixed.is-dot {
          top: 14px;
          left: -20px;
        }
      }
      &.first-level .el-badge__content.is-fixed.is-dot {
        top: 16px;
        left: -44px;
      }
    }
  }
  .sidebar-collapse {
    position: absolute;
    right: -16px;
    top: 50%;
    width: 16px;
    height: 56px;
    margin-top: -28px;
    background: url('https://s3.meituan.net/static-prod01/com.sankuai.bike.web.epartner-files/menu-collapse.png')
      no-repeat center center;
    background-size: cover;
    cursor: pointer;
    z-index: 99;
    &:hover {
      background-image: url('https://s3.meituan.net/static-prod01/com.sankuai.bike.web.epartner-files/menu-collapse-hover.png');
    }
    > .mtdicon {
      display: none;
    }
  }
}
</style>
